<!-- 系统节能 -->
<template>
    <div class='container containerBox'>
        <div class="handleForm" ref="handleForm">
            <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="选择年份">
                    <el-date-picker
                        v-model="form.time"
                        type="year"
                        placeholder="选择年"
                        value-format="yyyy"
                        @change="choseTime">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                    <el-button type="primary"><router-link to="/EnergySystemDay">查看日报</router-link></el-button>
					<el-button type="primary" @click="onSubmitin">导出报表</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="charts-box" >
            <div id="charts"  style="width: 100%;height:100%;"></div>
            <div class="nodata" v-show="energy_conservation.length === 0 && energy_air_sum.length === 0">
                --  暂无数据 --
            </div>
        </div>

        <div style="height:20px;"></div>
        <el-card class="box-card onlyenergysystem"  shadow="never">
            <div slot="header" class="clearfix bg">
                <span>报表明细{{energysystem_month}}</span>
            </div>
            <div class="energy-box">
                <ul class="situation-list">
                    <li class="situation-flex">
                        <span>节能基数：{{month_basic_energy}} kWh</span>
                        <span>总用电量：{{sum_electricity}} kWh</span>
                        <span>节约电量：{{energy_conservation_use}} kWh</span>
                    </li>
                    <li class="situation-flex situation-detail" v-if="sum_electricity_etail.length>0">
                        <template v-for="(v, i) in sum_electricity_etail">
                            <span class="report-detail-item" :key="i">
                                {{v.name}}：{{v.value}} kWh
                            </span>
                        </template>
                    </li>
                    <li class="situation-flex">
                        <span>节能率：{{energy_air_rate}} %</span>
                        <span>节约电费：{{energy_conservation_fee}} 元</span>
                        <span>分成率：{{divided_proportion}}</span>
                    </li>
                    <li class="situation-flex">
                        <span>自动时长：{{running_time}}</span>
                        <span>分成费：{{divided_proportion_fee}} 元</span>
                        <span></span>
                    </li>
                </ul>
            </div>
        </el-card>
		
		<el-dialog 
		:title="titlename"
        :visible.sync="showdown"
		:before-close="handleCloseDialog"
		>
		<el-form>
			<el-form-item label="选择时间">
					<el-date-picker
					v-model="choseplctime"
					type="monthrange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM"
					@blur="choseplcTime"
					>
					</el-date-picker>
			 </el-form-item>
			 <el-form-item label="PLC设备">
			     <el-select v-model="plcform.terminal_id" placeholder="请选择设备" >
			         <el-option
			             v-for="item in deviceList"
			             :key="item.oid"
			             :label="item.customized_serial+'：'+item.terminal_serial"
			             :value="item.oid">
			         </el-option>
			     </el-select>
			 </el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleCloseDialog">取 消</el-button>
			<el-button type="primary" @click="down">确 定</el-button>
		</div>
		</el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import echarts from "echarts"
import Service from '@/api/Service'
import { FormatDate, FormatDateDay,FormatPrevDate} from '@/utils/utils.js'
import config from '@/config.js'

const nowDay = FormatDate("yyyy-MM");
const prevDay = FormatPrevDate("yyyy-MM");


var charts = null
export default {
    name:  'energsystem',
    data() {
        return {
            form: {
                month: '',
                time: FormatDate('yyyy-MM-dd HH:mm:ss')
            },
			plcform:{
				project_sys_id:'',
				terminal_id:'',
				bill_type:"kongtiao",
				from:nowDay,
				to:prevDay,
			},
			titlename:'导出报表',
			showdown:false,
			choseplctime:'',
			deviceList:[],
            month: new Date().getMonth()+1,
			energysystem_month:'',//当前点击月份
            energy_conservation: [], // 总节约电费
            energy_air_sum: [],     //  空调总电费曲线

            energy_conservation_data: 0, // 总节约电费
            energy_air_data: 0,     //  空调节约电费

            energy_air_data1: 0,     //  空调节约电量
            energy_air_totle: 0,    //  水泵总电量

            month_basic_energy: 0,
            sum_electricity: 0,
            sum_electricity_etail: [],
            energy_conservation_use: 0,
            energy_conservation_fee: 0,
            divided_proportion: 0,
            divided_proportion_fee: 0,
            running_time_list: [],
        };
    },

    components: {},

    computed: {
        energy_air_rate() {
            //  节约电量/基础电量
            let num = (this.energy_conservation_use/this.month_basic_energy)
            if(isNaN(num) || num === Infinity) return 0
            let rate = (num*100).toFixed(2)

            return rate
        },
        // 运行时间
        running_time() {
            let arr = []
            this.running_time_list.map(v=>{
                arr.push(`${v.terminal_serial}: ${v.running_time.value}h`)
            })
            return arr.join(' / ')
        }
    },
	
    mounted() {
        this.$nextTick( async ()=>{

            // 基于准备好的dom，初始化echarts实例
            charts = echarts.init(document.getElementById('charts'));

            let time = FormatDate('yyyy-MM-dd HH:mm:ss')
            await this.getEnergyConservation(time)
            await this.getPLCStatisticByPIDTimeRange(time)
            await this.getSystemEnergyDetail(time);
        })
		this.getDeviceList()
    },

    methods: {
		//导出报表
		onSubmitin(){
			this.showdown=true
		},
		handleCloseDialog(){
			this.showdown=false
		},
		choseplcTime(val){
			this.plcform.from = val.value[0]
			this.plcform.to = val.value[1]
		},
        // 获取全部PLC
        async getDeviceList() {
            let params = Object.assign({}, { page_num: 1, page_sum: 40 });
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.deviceList = list;
                this.terminal_id = list[0].oid   
            }
        },
		//下载报表
		async down(){
			let res = await Service.getExport(this.plcform)
			if(res){
				if(res) {
						location.href = config.DEFAULT_FILE_PATH + res
				 }
				this.showdown = false;
			}
		},
        // 总节约电费   fee_conservation.energy_conservation
        async getEnergyConservation(time) {
            let res = await Service.getEnergyConservation({time});
            if(res) {
                let fee_conservation = res.fee_conservation
                
                // 空调总节约电费
                if(fee_conservation.energy_conservation && fee_conservation.energy_conservation.length>0) {
                    this.energy_conservation = fee_conservation.energy_conservation.map(v=>{return v.value})
                    // this.energy_conservation = this.energy_conservation[this.energy_conservation.length-1]
                }else{
					this.energy_conservation = 0
				}
            }
            
        },
        // 总电费   energy_air_sum   electricity_fee.sum_electricity_fee
        async getPLCStatisticByPIDTimeRange(time) {
            
            let res = await Service.getPLCStatisticByPIDTimeRange({time_range: "month", time});
            if(res) {
                let electricity_fee = res.electricity_fee
                
                // 空调总电费
                if(electricity_fee.sum_electricity_fee && electricity_fee.sum_electricity_fee.length>0) {
                    this.energy_air_sum = electricity_fee.sum_electricity_fee.map(v=>{return v.value})
                }else{
					this.energy_air_sum = []
				}
                this.initData()
            }
        },

        async getSystemEnergyDetail(time) {
            let month = this.month
            let res = await Service.getEnergyConservationByPIDMonthRange({month, time})
            if(res) {
                this.month_basic_energy = res.electricity_statistic.month_basic_energy
                this.sum_electricity = res.electricity_statistic.sum_electricity.toFixed(2)
                this.energy_conservation_use = res.electricity_statistic.energy_conservation.toFixed(2)
                this.energy_conservation_fee = res.fee_statistic.energy_conservation_fee.toFixed(2)
                this.divided_proportion = res.divided_proportion
                this.divided_proportion_fee = res.fee_statistic.divided_proportion_fee.toFixed(2)
                this.running_time_list = res.running_time_list || []

                let list = res.electricity_statistic.electricity_detail === null ? [] : res.electricity_statistic.electricity_detail
                this.sum_electricity_etail = list.map(v => {
                    return {
                        name: v.plc_terminal_type_name,
                        value: v.detail.value
                    }
                })
            }
        },
        choseTime(val) {
            if(!val) return
			const newval = val.toString() + "-12-31 23:59:59"
            this.form.time = newval
			this.month = 12
        },
        // 查询
        async onSubmit() {
            let time = this.form.time
			
			await this.getEnergyConservation(time)
			await this.getPLCStatisticByPIDTimeRange(time)
			// this.getSystemEnergyDetail(time);
        },
        handleToDay() {

        },
        initData() {
            this.initCharts(this.energy_conservation, this.energy_air_sum)
        },
        initCharts(nowDay, otherDay) {
            let that = this
            let option = this.getOption();
            option.series =  [
                {
                    name: '总节约电费',
                    type: 'bar',
                    stack: '电费',
                    data: nowDay,
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(56, 191, 96, 1)'
                        
                    },
                },
                {
                    name: '总电费',
                    type: 'bar',
                    smooth: true,
                    itemStyle: {
                        color: 'rgba(196, 178, 27, 1)'
                    },
                    data: otherDay,
                },
            ]
            charts.setOption(option);
			//柱状图点击事件
            charts.on('click', (params) => {
                if(params.seriesType === 'bar') {
                    that.month = params.dataIndex + 1;//获取月份
					const unit='月份';
					that.energysystem_month = ':' + that.month+unit;//获取当前点击月份
                    let time = this.form.time;
                    that.getSystemEnergyDetail(time);
                }
            });
        },
        getOption() {
            return {
                tooltip: {
                    trigger: 'axis',
                    padding: [
                        5,  // 上
                        10, // 右
                        5,  // 下
                        10, // 左
                    ],
                    axisPointer: {
                        type: 'cross',
                    }
                },
                legend: {
                    data: ['总节约电费', '总电费'],
                    right: 160,
                    top: 10,
                },
                grid: {
                    left: 70,
                    right: 20,
                    bottom: 30,
                    top: 30,
                },
                
                xAxis: [
                    {
                        type: 'category',
                        data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
                    },
                ],

                yAxis: [
                    {
                        type: 'value',
                        name: '元',
                    }
                ],
                series: [
                    {
                        name: '总节约电费',
                        type: 'bar',
                        stack: '电费',
                        data: [],
                        smooth: true,
                        itemStyle: {
                            color: 'rgba(56, 191, 96, 1)'
                        },
                    },
                    {
                        name: '总电费',
                        type: 'bar',
                        smooth: true,
                        itemStyle: {
                            color: 'rgba(196, 178, 27, 1)'
                        },
                        data: [],
                    },
                ],
            }
        }
    }
}

</script>
<style lang='less' scoped>
    .situation-list{
        margin: 10px;
        .situation-flex{
            border-bottom: 1px solid #EBEEF5;
            display: flex;
            flex-direction: row;
            span{
                flex: 1;
                text-align: left;
                font-size: 14px;
                color: #666;
                line-height: 40px;
                margin: 10px 0;
                text-align: left;
                padding: 0 20px;
                &:nth-child(2){
                    border-left: 1px solid #EBEEF5;
                    border-right: 1px solid #EBEEF5;
                }
            }
        }
    }
    .charts-box{
        height: 400px;
    }
    .situation-detail {
        border-radius: 15px;
        margin: 15px 50px;
        border-bottom: 0;
        background-color: #e0e5fa;
        position: relative;
        &::before{
            content: "";
            position: absolute;
            left: 50%;
            top: -20px;
            margin-left: -10px;
            display: inline-block;
            border-top: 10px transparent dashed;
            border-left: 10px transparent dashed;
            border-right: 10px transparent dashed;
            border-bottom: 10px #e0e5fa solid;
        }
    }

</style>
<style lang='less'>
	.onlyenergysystem .el-card__header{
		background:rgb(41, 61, 110);
		color: #FFFFFF;
		text-align:center;
	}	
</style>